<template>
    <div class="col-lg-6 col-md-6 col-12">
        <router-link :to="`/work/${project.id}`" class="project_card">
            <div class="image">
                <img :src="project.main_image" :alt="project.title">
                <div class="hover-overlay"></div> <!-- New div for background -->
            </div>
            <p class="title">{{ project.title }}</p>
        </router-link>
    </div>
</template>
  
<script>
    export default {
        name: "project-card",
        props: {
            project: Object
        }
    }
</script>

<style>

</style>